import React, { useEffect, useRef } from "react";
import { useLocation } from "react-router-dom";
import { ErrorBox } from "@amzn/burberry-ui-components";
import { awsRum } from "src/rum";
import { metricEmitter } from "src/utils/metricEmitter";

export interface ErrorPageProps {
  heading: string;
  message: string;
  pageName: string;
}

const ErrorPage: React.FC<ErrorPageProps> = ({ heading, message, pageName }) => {
  const location = useLocation();
  const pageLoadTime = useRef(Date.now());

  useEffect(() => {
    awsRum?.recordEvent("PageView", {
      page: pageName,
      path: location.pathname,
    });
  }, [location.pathname, pageName]);

  useEffect(() => {
    const loadTime = Date.now() - pageLoadTime.current;
    awsRum?.recordEvent("PageLoad", {
      page: pageName,
      loadTimeMs: String(loadTime),
    });
  }, [pageName]);

  return (
    <div className="errorPage" data-testid="errorPage">
      <ErrorBox
        heading={heading}
        message={message}
        metricEmitter={metricEmitter}
      />
    </div>
  );
};

export default ErrorPage;
